import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AiTooltipService } from './tooltip.service';

@NgModule({
  imports: [CommonModule],
  providers: [AiTooltipService]
})
export class AiTooltipModule {}
